
    import {defineComponent} from 'vue';
    import {bool, string} from 'vue-types';

    enum StepMobileHeaderEvents {
        CLICK_PREVIOUS = 'click:previous',
    }

    export default defineComponent({
        name: 'StepMobileHeader',
        components: {},
        emits: [StepMobileHeaderEvents.CLICK_PREVIOUS],
        props: {
            stepName: string().isRequired,
            showButtonPrevious: bool().def(true),
        },
        setup(props, {emit}) {
            function handleClickOnPrevious(): void {
                emit(StepMobileHeaderEvents.CLICK_PREVIOUS);
            }

            function dataTestId(action: string): string {
                return `step-${props.stepName}-actions-cta-${action}`;
            }

            return {
                handleClickOnPrevious,
                dataTestId,
            };
        },
    });
